import React, { useState, useRef } from 'react';
import Sidebar from './Sidebar';
import Header from './Header';
import { Box, useTheme, useMediaQuery } from '@mui/material';
import { useLocation } from 'react-router-dom';

const Layout = ({ children }) => {
  const location = useLocation();
  const contentRef = useRef(null);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(true);
  const [mobileOpen, setMobileOpen] = useState(false);

  const showSidebar = !['/login', '/admin', '/signup', '/forgot-password'].includes(location.pathname);
  const sidebarWidth = isMobile ? 0 : (isSidebarCollapsed ? 64 : 180);

  const handleDrawerToggle = () => {
    if (isMobile) {
      setMobileOpen(!mobileOpen);
    } else {
      setIsSidebarCollapsed(!isSidebarCollapsed);
    }
  };

  return (
    <Box sx={{ display: 'flex', height: '100vh', overflow: 'hidden' }}>
      {showSidebar && (
        <Sidebar
          isCollapsed={isSidebarCollapsed}
          onToggle={handleDrawerToggle}
          mobileOpen={mobileOpen}
          onMobileClose={() => setMobileOpen(false)}
          isMobile={isMobile}
        />
      )}

      <Box
        sx={{
          flexGrow: 1,
          display: 'flex',
          flexDirection: 'column',
          width: showSidebar ? `calc(100% - ${sidebarWidth}px)` : '100%',
          marginLeft: isMobile ? 0 : (showSidebar ? '0.5rem' : 0),
          transition: 'margin-left 0.3s ease, width 0.3s ease',
          overflow: 'hidden',
          paddingTop: showSidebar ? '64px' : 0, // No space for header on login/signup
        }}
      >
        {showSidebar && (
          <Header
            isSidebarCollapsed={isSidebarCollapsed}
            onDrawerToggle={handleDrawerToggle}
            isMobile={isMobile}
          />
        )}

        {/* ✅ REAL SCROLL CONTAINER */}
        <Box
          ref={contentRef}
          id="main-content-wrapper"
          sx={{
            flexGrow: 1,
            overflowY: 'auto',
            height: showSidebar ? 'calc(100vh - 64px)' : '100vh',
            p: showSidebar ? { xs: 1, md: 2 } : 0, // No padding for login/signup
          }}
        >
          {children}
        </Box>
      </Box>
    </Box>
  );
};

export default Layout;
